export default "__VITE_ASSET__BJX5glvz__"